module.exports = __webpack_public_path__ + "img/ic_profile_gray.5bd57921.svg";